<template>
  <div class="about-container">
    <div class="about">
      <div class="about-header">
        <video id="myVideo2" loop muted data-autoplay playsinline>
          <source src="/cg4.mp4" type="video/mp4">
        </video>
        <p>
上海识加电子科技有限公司专注于人工智能技术研发与应用的新锐科技公司，致力于养殖行业管理自动化、智能化。拥有硬件、软件和算法共25人的开发团队。我们有丰富运输行业管理经验的海归CEO，有香港理工大学首席教授、全球高引论文学者作为技术合伙人，有经验丰富的研发管理团队，掌握人工智能核心技术。
      </p>
      </div>
      <!--			<h1 :class="{'fadeInDown': sectionsIndex==3}">-->
      <!--				<span>关于我们</span>-->
      <!--				<span class="line"></span>-->
      <!--			</h1>-->
      <!--			<p>识加科技（上海）有限公司是一家基于计算机视觉，专注于人工智能技术研发与应用的新锐科技公司。提供便捷高效的“行车安全管理解决方案”，致力于帮助运输企业有效地降低交通事故发生率，提高风险控制能力。</p>-->
      <!--			<p>公司已拥有硬件产品：ADAS、右转弯车速监控系统、行车路线管理、驾驶员身份和全面行为识别及监督控制、夜间和复杂光线等复杂路况背景下的物体发现和追踪及辅助驾驶系统等；</p>-->
      <!--			<p>软件平台：虎加行车安全管理平台。</p>-->
      <!--			<p>“右转弯车速监控系统”已经率先为企业解决了『右转弯时』交通死亡事故不可控的行业难题。杜绝了80%以上的交通死亡事故。</p>-->
      <!--			<p>公司已通过高新技术企业认证，并获得了发明、实用新型、著作权商标等知识产权50多项。</p>-->
    </div>

    <div class="contact">
      <div class="code">
        <!--				<div>-->
        <!--					<div><img src="../../assets/images/qcode1.png" alt=""></div>-->
        <!--					<div>虎加平台</div>-->
        <!--				</div>-->
        <!--				<div>-->
        <!--					<div><img src="../../assets/images/qcode2.png" alt=""></div>-->
        <!--					<div>工地安全</div>-->
        <!--				</div>-->
      </div>

      <div style="flex: .7"></div>
<!--      <div class="tel">400-882-1689</div>-->

      <div class="contact-info">
        <div>
          <Qrcode class="qrcode-mobile" text="识加科技"/>
        </div>

        <div>
          <div class="address">公司：上海识加电子科技有限公司</div>
          <div class="address">地址：上海市静安区新闸路1001号2楼</div>
        </div>
      </div>
    </div>

    <div class="company" :class="{'fadeInUpBig': sectionsIndex==3}">
      <div><span>Copyright©2019，Nopluz Technology (Shanghai) Co., Ltd. All Rights Reserved.</span> 上海识加科技有限公司
      </div>
      <a href="http://www.beian.miit.gov.cn" target="_blank">沪ICP备16034377号-1</a>
    </div>

    <Qrcode class="qrcode" text="识加科技"/>
  </div>
</template>

<script>
import Qrcode from "@/views/qrcode.vue";

export default {
  components: {Qrcode},
  props: ['sectionsIndex']
}
</script>

<style lang="scss"></style>
